import React from "react";
import Layout from "../components/layout"
import SEO from "../components/seo"
import Hero from "../components/hero"
import HeroImage from "../images/HouseIndustry.jpg"
import HeroText from "../components/HeroText"
import HomeServicesSpanish from "../components/HomeServicesSpanish"
import HomeReviewsSpanish from "../components/HomeReviewsSpanish"
import HomeCouponSpanish from "../components/HomeCouponSpanish"
import HomeContactSpanish from "../components/HomeContactSpanish"




const Espanol = () => {

  return (
    <Layout>
      <SEO title="Espanol" />
      <Hero darken={.2} source={HeroImage} h={"100vh"}>
        <div className="container is-fullhd">
          <div className="columns">
            <div className="column is-three-quarters-desktop is-full">
              <HeroText pos="relative" t="40vh" l="1vw">
                <h2>Residencial & Comercial</h2>
                <h4>El mejor servicio de HVAC de una compañía en la que puedes confiar.</h4>
              </HeroText>
            </div>
          </div>

        </div>
      </Hero>

      <HomeServicesSpanish/>
      <HomeReviewsSpanish/>
      <HomeCouponSpanish/>
      <HomeContactSpanish/>
    </Layout>

  )
}

export default Espanol;